import { FormasPagamento } from './constants'

export const StatusBoletoCarrinho = {
  Pago: 'Pago',
  AguardandoPagamento: 'Aguardando Pagamento',
  Falha: 'Falha ao gerar',
  EmGeracao: 'Em Geração',
  AguardandoFormaPagamento: 'Aguardando Forma Pagamento',
  EmEspera: 'Em Espera'
}

export function getStatusBoleto (sucesso, falha, agendamento, pago, forma_pagamento) {
  if (forma_pagamento === FormasPagamento.Link) {
    return StatusBoletoCarrinho.AguardandoFormaPagamento
  }
  if (forma_pagamento === FormasPagamento.Boleto) {
    switch (true) {
      case pago:
        return StatusBoletoCarrinho.Pago
      case sucesso:
        return StatusBoletoCarrinho.AguardandoPagamento
      case falha:
        return StatusBoletoCarrinho.Falha
      case agendamento:
        return StatusBoletoCarrinho.EmGeracao
      default:
        return StatusBoletoCarrinho.EmEspera
    }
  }
  return pago ? StatusBoletoCarrinho.Pago : StatusBoletoCarrinho.AguardandoPagamento
}
